import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'details-button',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './details-button.component.html',
  styleUrl: './details-button.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class DetailsButtonComponent{
  public text: InputSignal<string> = input.required<string>();
  public isSpeakerEntry: InputSignal<boolean> = input<boolean>(false);
  public isActionButton: InputSignal<boolean> = input<boolean>(false);
}